<script setup lang="ts">
  import { useAppLoading } from './loading-provider.vue'
  import Spinner from '../../spinner.vue'
  import SpinnerChase from '../../spinner-chase.vue'
  import type { HTMLAttributes } from 'vue'
  export interface LoadingSpinnerProps {
    id?: string
    isLoading?: boolean
    chase?: boolean
    class?: HTMLAttributes['class']
  }

  const props = defineProps<LoadingSpinnerProps>()

  const { isLoading } = useAppLoading()
</script>

<template>
  <template v-if="props.chase">
    <spinner-chase
      v-if="props.isLoading || isLoading(props.id)"
      :class="props.class"
    />
  </template>
  <spinner
    v-else-if="props.isLoading || isLoading(props.id)"
    :class="props.class"
  />
</template>
